jQuery(function ($) {
	
    let beSeminarWrapper = $('#seminar-courses-1tool-listing-view')
    let switcherButton = $('.seminar-courses-1tool__switcher__item')

    switcherButton.on('click', function () {
        if (!$(this).hasClass('active')) {
            switcherButton.removeClass('active')
            $(this).addClass('active')

            let view = $(this).attr('data-switch')
            beSeminarWrapper.removeClass('view-list view-grid');
            beSeminarWrapper.addClass('view-'+view);
        }
    })

})